import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import SiteFooter from './components/layout/SiteFooter';
import SiteHeader from './components/layout/SiteHeader';
import AllGenesPage from './pages/AllGenesPage';
import HelpPage from './pages/HelpPage';
import HomePage from './pages/HomePage';
import MethodsPage from './pages/MethodsPage';
import TransmembranePage from './pages/TransmembranePage';

const pageTitles = {
  '/': 'Brendo | Brain endothelial open resource',
  '/transmembrane': 'Transmembrane Focus | Brendo',
  '/all-genes': 'All genes | Brendo',
  '/methods': 'Methods | Brendo',
  '/help': 'Help & support | Brendo',
};

function RouteEffects() {
  const { pathname } = useLocation();
  const previousPath = useRef(pathname);

  useEffect(() => {
    document.title = pageTitles[pathname] || 'Brendo | Brain endothelial open resource';
    if (previousPath.current !== pathname) {
      document.getElementById('main-content')?.focus();
    }
    previousPath.current = pathname;
  }, [pathname]);

  return null;
}

export function AppRoutes() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <RouteEffects />
      <Box
        component="a"
        href="#main-content"
        className="skip-link"
      >
        Skip to main content
      </Box>
      <SiteHeader />
      <Box component="main" id="main-content" tabIndex={-1} sx={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/transmembrane" element={<TransmembranePage />} />
          <Route path="/all-genes" element={<AllGenesPage />} />
          <Route path="/methods" element={<MethodsPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Box>
      <SiteFooter />
    </Box>
  );
}

export default function App() {
  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <AppRoutes />
    </BrowserRouter>
  );
}
